import { useAtom } from 'jotai/index';
import { useEffect, useRef, useState } from 'react';

import { expandStoreStampIdAtom } from '../../../atoms/stampAtoms';

function useCardExpand(shopId: string) {
    const [expandId, setExpandId] = useAtom(expandStoreStampIdAtom);
    const ref = useRef<HTMLDivElement>(null);
    const expand = shopId === expandId;
    const [logExpand, setLogExpand] = useState<boolean>(false);
    const handleExpand = () => {
        setLogExpand(false);
        if (expand) {
            setExpandId('');
        } else {
            setExpandId(shopId);
            const scrollTimeout = setTimeout(() => {
                ref.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest',
                });
            }, 400);
            return () => clearTimeout(scrollTimeout);
        }
        return () => {};
    };
    useEffect(() => {
        setLogExpand(false);
    }, [expand]);

    return {
        handleExpand, expand, logExpand, ref, setLogExpand,
    };
}

export default useCardExpand;
